<div class="auth-shell">
  <!-- Acciones flotantes: en desktop quedan top-right del brand-panel
       (izquierda), en mobile top-right del viewport. El posicionamiento
       lo maneja CSS con `right: calc()` + media queries. -->
  <div class="auth-floating-actions">
    <language-switcher class="auth-lang-switcher"></language-switcher>

    <button
      type="button"
      class="auth-theme-toggle"
      [class.is-dark]="isDark()"
      (click)="toggleTheme()"
      [attr.aria-label]="(isDark() ? 'auth.tema.switchToLight' : 'auth.tema.switchToDark') | translate"
      [title]="(isDark() ? 'auth.tema.light' : 'auth.tema.dark') | translate">
      <span class="toggle-track">
        <span class="toggle-thumb">
          <svg *ngIf="!isDark()" class="toggle-icon" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
            <circle cx="12" cy="12" r="4" fill="currentColor"/>
            <g stroke="currentColor" stroke-width="2" stroke-linecap="round">
              <line x1="12" y1="2" x2="12" y2="5"/>
              <line x1="12" y1="19" x2="12" y2="22"/>
              <line x1="2" y1="12" x2="5" y2="12"/>
              <line x1="19" y1="12" x2="22" y2="12"/>
              <line x1="4.93" y1="4.93" x2="7.05" y2="7.05"/>
              <line x1="16.95" y1="16.95" x2="19.07" y2="19.07"/>
              <line x1="4.93" y1="19.07" x2="7.05" y2="16.95"/>
              <line x1="16.95" y1="7.05" x2="19.07" y2="4.93"/>
            </g>
          </svg>
          <svg *ngIf="isDark()" class="toggle-icon" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
            <path d="M21 12.8 A9 9 0 1 1 11.2 3 a7 7 0 0 0 9.8 9.8 z" fill="currentColor"/>
          </svg>
        </span>
      </span>
    </button>
  </div>

  <!-- ===== Brand panel (desktop / tablet) ===== -->
  <aside class="brand-panel">
    <div class="brand-content">
      <!-- Sin logo: la marca vive en la card del form. El brand-panel
           arranca directo con el eyebrow + headline. -->

      <div class="brand-eyebrow">
        <span class="eyebrow-line"></span>
        <span class="eyebrow-text">{{ 'brand.platform' | translate }}</span>
      </div>

      <h1 class="brand-headline">
        {{ 'brand.headlineLine1' | translate }}<br/>
        <span class="gradient-text">{{ 'brand.headlineLine2' | translate }}</span>
      </h1>

      <p class="brand-tagline">{{ 'brand.tagline' | translate }}</p>

      <div class="brand-features">
        <div class="feature">
          <span class="feature-icon">
            <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
              <path d="M5 12l5 5L20 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span>{{ 'brand.features.f1' | translate }}</span>
        </div>
        <div class="feature">
          <span class="feature-icon">
            <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
              <path d="M5 12l5 5L20 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span>{{ 'brand.features.f2' | translate }}</span>
        </div>
        <div class="feature">
          <span class="feature-icon">
            <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
              <path d="M5 12l5 5L20 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span>{{ 'brand.features.f3' | translate }}</span>
        </div>
      </div>

      <div class="trust-row" [attr.aria-label]="'brand.trust.ariaLabel' | translate">
        <div class="trust-item">
          <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
            <path d="M12 2 L4 6 v6 c0 5 3.5 8.5 8 10 4.5-1.5 8-5 8-10 V6 z"
                  fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
            <path d="M9 12 l2 2 4-4" fill="none" stroke="currentColor" stroke-width="1.8"
                  stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>{{ 'brand.trust.tls' | translate }}</span>
        </div>
        <span class="trust-sep"></span>
        <div class="trust-item">
          <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
            <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.8"/>
            <path d="M8 12 l3 3 5-6" fill="none" stroke="currentColor" stroke-width="1.8"
                  stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>{{ 'brand.trust.iso' | translate }}</span>
        </div>
        <span class="trust-sep"></span>
        <div class="trust-item">
          <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
            <path d="M12 2 C7 7 7 12 12 17 C17 12 17 7 12 2 Z M12 17 L12 22"
                  fill="none" stroke="currentColor" stroke-width="1.8"
                  stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>{{ 'brand.trust.eco' | translate }}</span>
        </div>
      </div>
    </div>

    <div class="brand-footer">
      <div class="copyright">© {{ year }} IONICS · ionics.com.ar</div>
      <div class="version">{{ 'brand.version' | translate }}</div>
    </div>
  </aside>

  <!-- ===== Form panel (derecha) ===== -->
  <main class="form-panel">
    <!-- Sin mobile-brand header: la marca ya vive en la card del form. -->

    <dx-scroll-view height="100%" width="100%" class="form-scroll">
      <div class="form-container">
        <!-- El shell provee la card chrome (logo + título + sombra). La página
             hija (sign-in-form, reset-password-form, etc) emite SOLO su
             formulario via router-outlet → ng-content. -->
        <app-card-auth
          [title]="titleKey ? (titleKey | translate) : ''"
          [description]="descriptionKey ? (descriptionKey | translate) : ''">
          <ng-content></ng-content>
        </app-card-auth>

        <p class="legal-line">
          {{ 'auth.legal.intro' | translate }}
          <a href="#" tabindex="-1">{{ 'auth.legal.terms' | translate }}</a>
          {{ 'auth.legal.and' | translate }}
          <a href="#" tabindex="-1">{{ 'auth.legal.privacy' | translate }}</a>.
        </p>
      </div>
    </dx-scroll-view>
  </main>
</div>
